// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  databaseName: __t.string().name("database_name"),
  moduleTypeName: __t.string().name("module_type_name"),
  version: __t.u64(),
  wasmHash: __t.string().name("wasm_hash"),
  deployedAt: __t.timestamp().name("deployed_at"),
  success: __t.bool(),
});
